import {useEffect} from 'react';
import {useSelector} from 'react-redux';
import {isEmpty} from 'lodash';
import {flow, toInteger, toString} from 'lodash/fp';

import {UpdateNotesAlert} from '/component/partial/UpdateNotesAlert/UpdateNotesAlert';
import {usePopup} from '/provider/PopupProvider';
import {
  variablesBuildNumber,
  variablesUpdateNotes,
} from '/redux/selector/remoteConfig.selector';
import {createStorage} from '/util/async-storage';
import {getAppBuildNumber} from '/util/device-info.util';

import {STORAGE_KEY} from './UpdateNotesProvider.constant';

export function useUpdateNotesPopup() {
  const updateNotes = useSelector(variablesUpdateNotes);
  const buildNumber = useSelector(variablesBuildNumber);

  // @ts-expect-error TS(2339): Property 'hidePopup' does not exist on type 'unkno... Remove this comment to see the full error message
  const {hidePopup, showPopup} = usePopup();

  useEffect(() => {
    // No need to show an alert when data is not provided.
    // TODO: Validate `updateNotes` structure and log error to Crashlytics
    if (isEmpty(updateNotes)) {
      return;
    }

    // The value indicates for which app version the What's New alert
    // has already been presented.
    const {getValue: getBuildNumber, setValue: setBuildNumber} = createStorage({
      key: STORAGE_KEY,
      serialize: toString,
      parse: toInteger,
    });

    getBuildNumber().then(presentedFor => {
      const appBuildNumber = getAppBuildNumber();

      // If an alert has already been presented, no need to show it again.
      if (presentedFor === appBuildNumber) {
        return;
      }

      // If the current app version is the most recent, present an alert.
      // The `buildNumber` should not be more than `appBuildNumber`, technically
      // it's possible only within development process.
      if (appBuildNumber === buildNumber) {
        showPopup(
          UpdateNotesAlert,
          {
            notes: updateNotes,
            onConfirm: flow([hidePopup, () => setBuildNumber(appBuildNumber)]),
          },
          {
            avoidable: false,
          },
        );
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
